import { useRef } from "react";
import confetti from "canvas-confetti";

export function useConfetti(options) {
    const ref = useRef();
    return [
        ref,
        () => {
            const mediaQuery = matchMedia("(prefers-reduced-motion: no-preference)");
            if (mediaQuery?.matches) {
                const {
                    top,
                    height,
                    left,
                    width
                } = ref.current.getBoundingClientRect();
                const x = (left + width / 2) / window.innerWidth;
                const y = (top + height / 2) / window.innerHeight;
                confetti({
                    origin: { x, y },
                    particleCount: 500,
                    angle: 60,
                    spread: 640,
                    ...options
                });
            }
        }
    ];
}
